import React, { useEffect, useRef } from "react";
import { TiStar } from "react-icons/ti";
import { AiOutlineShareAlt } from "react-icons/ai";
import { GiTicket } from "react-icons/gi";
import { CalendarDays } from "lucide-react";
import { Clock4 } from "lucide-react";
import dayjs from "dayjs";

const formatTimeToAMPM = (timeString) => {
  if (timeString === undefined) return;
  const [hours, minutes] = timeString.split(":").map(Number);

  // Construct a dayjs object with the provided hours and minutes
  const time = dayjs().set("hour", hours).set("minute", minutes);

  // Format the time to AM/PM format using dayjs
  const formattedTime = time.format("hh:mm A");

  return formattedTime;
};
export default function EventDetails({ eventDetail }) {
  let address = "";
  let latitude = "";
  let longitude = "";

  if (eventDetail && eventDetail?.location.length > 0) {
    const parts = eventDetail?.location?.split("|");
    parts.forEach((part) => {
      const [key, value] = part.split(":");

      if (key === "address") {
        const formattedValue = value
          .split(",") // Split at commas
          .map((part) => part.split(/(?=[A-Z])/).join(" ")) // Split at capital letters and join with space
          .join(", "); // Join with comma and space
        address = formattedValue;
      } else if (key === "latitude") {
        latitude = value;
      } else if (key === "longitude") {
        longitude = value;
      }
    });
  }

  const formattedAddress = eventDetail?.location
    .split(",")
    .map((part) => part.split(/(?=[A-Z])/).join(" "))
    .join(", ");

  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // Reset height to auto to shrink if needed
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set height to match content
    }
  }, [eventDetail?.description]); // Re-run effect whenever description changes

  return (
    <div className="space-y-10 flex flex-col my-10">
      <h2 className="text-4xl font-bold">Event Details</h2>

      <div className="flex justify-between flex-wrap space-y-5">
        <div className="space-y-2">
          <h2 className="text-2xl font-semibold">Date and Time</h2>
          <div className="space-y-2">
            <p className="flex gap-2 items-center">
              <CalendarDays />
              {dayjs(new Date(eventDetail?.eventdate)).format("YYYY-MM-DD")}
              {/* Saturday, 2 December 2023 */}
            </p>
            <p className="flex gap-2 items-center w-full">
              <Clock4 />
              {formatTimeToAMPM(eventDetail?.startime)} -{" "}
              {formatTimeToAMPM(eventDetail?.enddate)}
            </p>
          </div>
        </div>

        <div>
          <button className="bg-yellow-400 text-black font-semibold hover:bg-yellow-400 flex gap-2 rounded-md p-4 items-center capitalize">
            <GiTicket className="mr-2 h-4 w-4" />
            <span>{eventDetail?.type}</span> event
          </button>
        </div>
      </div>
      <div className="flex flex-col">
        <div>
          <h2 className="text-2xl font-semibold">Location</h2>
        </div>

        <div className="flex mb-4">
          <p>{formattedAddress}</p>
        </div>
      </div>

      <div className="space-y-5">
        <div>
          <h2 className="text-2xl font-semibold">Event Description</h2>
        </div>
        <textarea
          readOnly
          ref={textareaRef}
          className="w-full resize-none scrollbar border-0 focus:outline-none"
          rows={1}
          value={eventDetail?.description}
        />
      </div>
      <div className="flex flex-col max-w-5xl mr-auto">
        <div>
          <h2 className="text-2xl font-semibold mb-4">Speaker(s)</h2>
        </div>

        <div className="flex">
          <p>{eventDetail?.speaker}</p>
        </div>
      </div>
    </div>
  );
}
